import Autoplay from "slotworks/state-machine/standard/states/autoplay";
import RevolverSettings from "model/revolver-settings";
import soundManager from "slotworks/sound/sound-manager";

export default class ICAutoplay extends Autoplay {
    
    public onEnter() {
        if(RevolverSettings.winCount == 0 || Date.now() - RevolverSettings.lastWinTime > 10000) {
            soundManager.customEvent("base_music");
            RevolverSettings.winCount = 0;
        }
        super.onEnter();
    }
}